<template>
  <div class="papers-wrap">
    <advertising-figure />
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Submission of papers</span>
      </public-title>

      <div class="papers">
        <div class="papers-form-wrap">
          <el-button type="primary" style="margin-top: 0px;"  @click="openNotice">投稿须知</el-button>
          <el-button type="primary" style="margin-top: 0px;" @click="downloadTemp">下载论文模板</el-button>
          <div class="papers-form">
            <h2 class="form-tit">报名投稿</h2>
            <!-- <p class="papers-num">论文编号: <span>0123456789987654321</span></p> -->
            <papers-form
              ref="papersForm"
              :form="papersForm"
              :list="paperFormList"
              :btns="btns"
              :rules="rules"
              labelWidth="auto"
            />
          </div>
        </div>
        <div class="my-papers">
          <h2 class="my-papers-tit">我的投稿</h2>
          <ul v-if="treatises.length>0" class="my-paper-list" >
            <li class="item" v-for="(item, i) in treatises" :key="i">
              <el-row>
                <el-col :span="18">
                  <p class="text">论文题目: {{ item.title }}</p>
                  <p class="num">论文编号: {{ item.id }}</p>
                  <p class="author">论文作者: {{ item.authorname }}</p>
                  <p class="type">状态: {{ item.status }}<span v-if="item.status=='修改稿件' && item.ismodified">(已修改)</span></p>
                  <p v-if="(item.status=='修改稿件'||item.status=='录用'||item.status=='退稿') && item.actions.length>0 && item.actions[0].reason" class="type">意见: {{ item.actions[0].reason}}</p> 
                  

                </el-col>
                <el-col>
                  <p>
                    <el-button
                    size="small"
                    class="more"
                    type="primary"
                    @click="handleMore(item)"
                    >查看详情</el-button
                    >
                    <el-button
                    style="margin-left: 0px;"
                    v-if="(!item.ismodified && item.status=='修改稿件') || item.status=='已投稿'"
                    size="small"
                    type="primary"
                    @click="handleUpdate(item)"
                    >修改</el-button
                    >
                    <el-button
                    style="margin-left: 20px;"
                    v-if="item.status=='已投稿'"
                    size="small"
                    type="primary"
                    @click="handleDelete(item)"
                    >删除</el-button
                    >
                  </p>
                </el-col>
                <!-- <el-col><p style="font-size: 15px;">我们会将录用的论文推荐到《土木工程学报》</p></el-col> -->
              </el-row>
            </li>
        </ul>
          
              
              <!--<el-button
                  v-if="item.status=='退稿'"
                  size="small"
                  type="primary"
                  @click="handleUpdateCancel(item)"
                  >取消修改</el-button
                >-->
              
           
            <!-- <li class="item">
                            <p class="text">
                                论文题目: 论文题目论文题目论文题目
                            </p>
                            <p class="num">论文编号: 00124563</p>
                            <p class="author">论文作者: 张三</p>
                            <p class="type">状态: 未通过</p>
                            <el-button
                                size="small"
                                class="more"
                                type="primary"
                                @click="handleMore"
                                >查看详情</el-button
                            >
                        </li>
                        <li class="item">
                            <p class="text">
                                论文题目: 论文题目论文题目论文题目
                            </p>
                            <p class="num">论文编号: 00124563</p>
                            <p class="author">论文作者: 张三</p>
                            <p class="type">状态: 未通过</p>
                            <el-button
                                size="small"
                                class="more"
                                type="primary"
                                @click="handleMore"
                                >查看详情</el-button
                            >
                        </li> -->
          
          <ul v-if="treatises.length==0"><li>您没有投稿信息</li></ul>
        </div>
      </div>
    </div>

    <paper-dialog
      v-model="dialogShow"
      :dialogConfig="dialogConfig"
      @closeDialog="closeDialog"
    >
      <div class="dialog-info-wrap">
        <h2 class="dialog-tit">我的投稿</h2>
        <div class="info">
          <p>论文编号:   &nbsp;&nbsp;   {{this.dialogItem.id}}</p>
          <p>论文题目:     &nbsp;&nbsp;{{this.dialogItem.title}}</p>
          <p>第一作者姓名: {{this.dialogItem.authorname}}</p>
          <p>第一作者电话: {{this.dialogItem.authorphone}}</p>
          <p>第一作者单位: {{this.dialogItem.authorcompany}}</p>
          <p>通讯作者姓名: {{this.dialogItem.corauthorname}}</p>
          <p>通讯作者电话: {{this.dialogItem.corauthorphone}}</p>
          <p>通讯作者邮箱: {{this.dialogItem.corauthoremail}}</p>
          <p>状态: {{this.dialogItem.status}}</p>
          <!-- <p>审核时间:</p> -->
        </div>
      </div>
    </paper-dialog>

    <notice-dialog
      v-model="noticeShow"
      :dialogConfig="dialogConfig"
      @closeDialog="closeDialog"
    ><template>
      <div class="dialog-info-wrap">
        <h2 class="dialog-tit">投稿须知</h2>
        <div class="info">
          <RichHtml v-if="this.currentConference.treatisereq && this.currentConference.treatisereq.length>0" :content="this.currentConference.treatisereq[0].require"></RichHtml>
        </div>
      </div>
    </template>
    </notice-dialog>
    <papertemplate-dialog
      v-model="templateShow"
      :dialogConfig="dialogConfig"
      @closeDialog="closeDialog"
    >
      <div class="dialog-info-wrap" v-if ="this.currentConference.treatisereq && this.currentConference.treatisereq.length>0 && currentConference.treatisereq[0].file_metadata.length>0">
        <h2 class="dialog-tit">下载论文模板</h2>
       
        <div class="info" v-for="(item, i) in currentConference.treatisereq[0].file_metadata" :key="i">
          <el-row>
              <el-col :span="18">
            <span>{{item.filename}}</span>
              </el-col>
              <el-col :span="6">
            <el-button
                  size="small"
                  right
                  type="primary"
                  @click="download(item)"
                  >下载</el-button>
              </el-col>
            </el-row>
        </div>
      </div>
    </papertemplate-dialog>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>确定删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDelete">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";
import papersForm from "@components/form";
import papersUpload from "@components/upload";
import paperDialog from "@components/dialog";
import noticeDialog from "@components/paper/noticeDialog";
import papertemplateDialog from "@components/paper/papertemplateDialog";
import { Contributions } from "@/store/entity/contributions";
import merge from "lodash/merge";

import CurrentConferMixin from "@/mixin/CurrentConference";
import CurrentUserMixin from "@/mixin/CurrentUser";
import PapersMixin from "@/mixin/Papers";
import RichHtml from "@/components/RichHtml"
import { User } from "@/store/entity/user";
import { Conference } from "@/store/entity/conference";

export default {
  name: "PapersPage",
  components: {
    AdvertisingFigure,
    InnerPageNav,
    publicTitle,
    papersForm,
    paperDialog,
    noticeDialog,
    papertemplateDialog,
    RichHtml
  },
  mixins: [CurrentConferMixin, CurrentUserMixin, PapersMixin],
  data() {
    return {
      deleteitem:null,
      centerDialogVisible: false,
      title: "论文投稿",
      papersForm: {
        title: "",
        authorname: "",
        authorphone: "",
        authorcompany: "",
        corauthorname: "",
        corauthorphone: "",
        corauthoremail: "",
        file_metadata: [],
        actions:[]
      },
      /* 弹窗 */
      dialogShow: false,
      noticeShow: false,
      templateShow: false,
      dialogConfig: {
        width: "30%",
        center: true,
      },
      localItem: new Contributions(),
      dialogItem: new Contributions(),
      treatises: new Array(),
      rules: {
        title: [
          {
            required: true,
            message: "请输入论文题目",
          },
        ],
        authorname: [
          {
            required: true,
            message: "请输入第一作者姓名",
          },
        ],
        authorphone: [
          {
            required: true,
            message: "请输入第一作者电话",
            trigger: "blur",
          },
          {
            pattern:
            /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入第一作者正确手机号",
          },
        ],
        authorcompany: [
          {
            required: true,
            message: "请输入第一作者单位",
          },
        ],
        corauthorname: [
          {
            required: true,
            message: "请输入通讯作者姓名",
          },
        ],
        corauthorphone: [
          {
            required: true,
            message: "请输入通讯作者电话",
            trigger: "blur",
          },
          {
            pattern:
            /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入通讯作者正确手机号",
          },
        ],
        corauthoremail: [
          {
            required: true, 
            message: "请输入通讯作者邮箱"
          },
          {
            pattern:
              /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/,
            message: "请输入正确通讯作者电子邮箱",
          },
        ],
      },
    };
  },

  computed: {
    paperFormList() {
      return [
        {
          prop: "title",
          render: "ElInput",
          attrs: {
            placeholder: "论文题目",
          },
          position: {
            span: 24,
          },
        },
        {
          prop: "authorname",
          render: "ElInput",
          attrs: {
            placeholder: "第一作者姓名",
          },
          position: {
            span: 24,
          },
        },
        {
          prop: "authorphone",
          render: "ElInput",
          attrs: {
            placeholder: "第一作者电话",
          },
          position: {
            span: 24,
          },
        },
        {
          prop: "authorcompany",
          render: "ElInput",
          attrs: {
            placeholder: "第一作者单位",
          },
          position: {
            span: 24,
          },
        },
        {
          prop: "corauthorname",
          render: "ElInput",
          attrs: {
            placeholder: "通讯作者姓名",
          },
          position: {
            span: 24,
          },
        },
        {
          prop: "corauthorphone",
          render: "ElInput",
          attrs: {
            placeholder: "通讯作者电话",
          },
          position: {
            span: 24,
          },
        },
        {
          prop: "corauthoremail",
          render: "ElInput",
          attrs: {
            placeholder: "通讯作者邮箱",
          },
          position: {
            span: 24,
          },
        },
        {
          prop: "file_metadata",
          render: papersUpload,
          attrs: {
            action: ``, //上传地址
            limit: 2,
            listType: "text",
            uploadFileList:this.papersForm.file_metadata,
            autoUpload: true,
          },
          position: {
            span: 24,
          },
        },
      ];
    },
    btns() {
      return [
        {
          label: this.canSubmit?"提交投稿":this.changebtn,
          attrs: {
            style: `
                        width: 100%; 
                        background: ${this.canSubmit ? "#fe0000":"#999"};
                        color: #fff;
                        border: none
                        `,
            disabled: !this.canSubmit,
            class: "submit",
          },
          listeners: {
            click: this.handleFormSubmit,
          },
        },
      ];
    },
    // confertreatises(){
    //         // console.log(this.treatises)
    //         if(this.$store.state.conference.currentConference.id != undefined && this.$store.state.user.currentUser.id !==undefined ){
    //             let param = {
    //                 conference_id:this.$store.state.conference.currentConference.id,
    //                 created_by_id:this.$store.state.user.currentUser.id
    //             }

    //             Contributions.getList(param).then((result) =>{
    //                     // console.log(result.result)
    //                 this.treatises = result.result

    //             })

    //         }

    //      return this.treatises
    // }
    // confertreatises:{
    //     get: function (){
    //         console.log("confertreatises")
    //         let data = {}
    //         data.confer = this.$store.state.conference.currentConference
    //         data.userid = this.$store.state.user.currentUser.id
    //         if(this.$store.state.conference.currentConference == undefined ||this.$store.state.user.currentUser.id==0 ){
    //            return new Array
    //         }else{
    //             return this.getConfertreatise(this.$store.state.conference.currentConference.id,this.$store.state.user.currentUser.id).result
    //         }
    //     },
    //     set(confertreatises){
    //         console.log(confertreatises)
    //         if(this.$store.state.conference.currentConference == undefined ||this.$store.state.user.currentUser.id ==0 ){
    //            this.treatises =  new Array
    //         }else{
    //             this.treatises =  this.getConfertreatise(this.$store.state.conference.currentConference.id,this.$store.state.user.currentUser.id).result
    //         }
    //     }

    // }
    curReady() {
      if (
        this.$store.state.conference.currentConference.id &&
        this.$store.state.user.currentUser.id
      ) {
        return {
          confer_id: this.$store.state.conference.currentConference.id,
          user_id: this.$store.state.user.currentUser.id,
        };
      } else {
        return null;
      }
    },
    changebtn(){
      let d1 =new Date().getTime()
      let d2 = new Date(this.currentConference.submissiondeadline).getTime()
      let d3 = new Date(this.currentConference.submissionstart).getTime()
      if(d1<d3){
        return "投稿未开始"
      }
      if(d1>d2){
        return "投稿结束"
      }
    },
    canSubmit(){
      if(this.currentConference.submissionstart && this.currentConference.submissiondeadline){//配置了投稿开始和截止日期
        let d1 =new Date().getTime()
        let d2 = new Date(this.currentConference.submissiondeadline).getTime()
        let d3 = new Date(this.currentConference.submissionstart).getTime()
        if(d1<d3){
          return false;
        }
        if(d1>d2){//到了截止日期
          //到了投稿截止日期之后，新增不能用，修改仍然可以用
          if(this.papersForm.id){
            return true;
          }else{
            return false;
          }
        }else{//未到截止日期
          return true;
        }
      }else{//未配置投稿开始或截止日期
        return false;
      }
    }
  },
  watch: {
    curReady(nval, oval) {

      if (nval) {
        let param = {
          conference_id: nval.confer_id,
          created_by_id: nval.user_id,
        };

        Contributions.getList(param).then((result) => {
          this.treatises = result.result;
        });
      }
      
    },
  },

  created() {
    console.log(this.currentConference)
    if (this.curReady) {
      let param = {
        conference_id: this.$store.state.conference.currentConference.id,
        created_by_id: this.$store.state.user.currentUser.id,
      };

      Contributions.getList(param).then((result) => {
        this.treatises = result.result;
      });
    }
  },
  methods: {
    handleFormSubmit() {
      if (this.checkFiels()) {
        //如果是修改进行提示
        if(this.papersForm.id && this.papersForm.status=="修改稿件"){
          this.$confirm("确认提交？提交后将不能再次修改，请认真核对信息！","提示",{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //确认
              this.submit();
          }).catch(() => {
            //取消
          });
        }else{
          this.submit();
        }
      }
    },
    submit(){
      merge(this.localItem, this.papersForm);
      this.localItem.conference_id = this.currentConference.id;
      this.localItem.createOrUpdate().then((item) => {
        this.localItem = item;
        this.$message("提交成功");
        this.getConfertreatise(
          this.$store.state.conference.currentConference.id,
          this.$store.state.user.currentUser.id
        );
        this.papersForm = new Contributions();
        this.clearcheck("papersForm");
      });
    },
    clearcheck(formName){
      if(this.$refs[formName]){
          this.$nextTick(() => {
                this.$refs[formName].clearValidate()
            })
      } 
    },
    openNotice(){
      console.log(this.noticeShow)
      this.noticeShow =true
    },
    checkFiels() {
      if (!this.papersForm.title || this.papersForm.title.length ==0) {
        this.$message("论文题目不能为空");
        return false;
      } else if (
        !this.papersForm.authorname ||
        this.papersForm.authorname.length ==0
      ) {
        this.$message("第一作者姓名不能为空");
        return false;
      } else if (!this.papersForm.authorphone || this.papersForm.authorphone.length ==0) {
        this.$message("第一作者电话不能为空");
        return false;
      } else if (!this.checkPhone(this.papersForm.authorphone)) {
        this.$message("请正确输入第一作者电话");
        return false;
      } else if (
        !this.papersForm.authorcompany ||
        this.papersForm.authorcompany.length ==0
      ) {
        this.$message("第一作者单位不能为空");
        return false;
      } else if (
        !this.papersForm.corauthorname ||
        this.papersForm.corauthorname.length ==0
      ) {
        this.$message("通讯作者姓名不能为空");
        return false;
      } else if (!this.papersForm.corauthorphone || this.papersForm.corauthorphone.length ==0) {
        this.$message("通讯作者电话不能为空");
        return false;
      } else if (!this.checkPhone(this.papersForm.corauthorphone)) {
        this.$message("请正确输入通讯作者电话");
        return false;
      } else if (!this.papersForm.corauthoremail || this.papersForm.corauthoremail.length ==0) {
        this.$message("通讯作者邮箱不能为空");
        return false;
      }  else if (!this.checkEmail(this.papersForm.corauthoremail)) {
        this.$message("请正确输入通讯作者邮箱");
        return false;
      }else if (!this.papersForm.file_metadata) {
        this.$message("请上传稿件");
        return false;
      } else if (this.papersForm.file_metadata.length!=2) {
        this.$message("必须上传‘摘要’和‘全文’2个附件");
        return false;
      }else {
        return true;
      }
    },
    checkDate() {
      if (!this.papersForm.title || this.papersForm.title.length > 60) {
        this.$message("论文题目不能为空且不能多于60个字");
        return false;
      } else if (
        !this.papersForm.authorname ||
        this.papersForm.authorname.length > 15
      ) {
        this.$message("第一作者姓名不能为空且不能多于15个字");
        return false;
      } else if (!this.checkPhone(this.papersForm.authorphone)) {
        this.$message("请正确输入第一作者电话");
        return false;
      } else if (
        !this.papersForm.corauthorname ||
        this.papersForm.corauthorname.length > 15
      ) {
        this.$message("通讯作者姓名不能为空且不能多于15个字");
        return false;
      } else if (!this.checkPhone(this.papersForm.corauthorphone)) {
        this.$message("请正确输入通讯作者电话");
        return false;
      } else if (!this.checkEmail(this.papersForm.corauthoremail)) {
        this.$message("请正确输入通讯作者邮箱");
        return false;
      } else if (!this.papersForm.file_metadata) {
        this.$message("请上传稿件");
        return false;
      } else {
        return true;
      }
    },
    checkEmail(email) {
      var reg =
        /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
      if (!reg.test(email)) {
        return false;
      }
      return true;
    },
    checkPhone(phone) {
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!reg.test(phone)) {
        return false;
      }
      return true;
    },
    handleMore(item) {
        console.log(item)
        this.dialogShow = true
        this.dialogItem = item
    },
    async handleUpdate(item) {
      this.$confirm("注意：修改内容后，点击【提交投稿】按钮才能完成修改","提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        //确认
          this.papersForm = await Contributions.getById(item.id)
      }).catch(() => {
        //取消
        this.handleUpdateCancel(item);
      });
    },
    handleDelete(item) {
      //Contributions.delete(item.id)
      this.centerDialogVisible = true
      this.deleteitem = item
    },
    confirmDelete(){
      Contributions.delete(this.deleteitem.id).then(()=>{
        let inx = this.treatises.indexOf(this.deleteitem);
        if(inx>-1){
          this.treatises.splice(inx,1);
        }
        this.papersForm = new Contributions();
        this.clearcheck("papersForm");
        this.centerDialogVisible = false;
      });
    },
    handleUpdateCancel(item) {
      this.papersForm = new Contributions();
      this.clearcheck("papersForm");
    },
    closeDialog(done) {
      done();
    },
    getConfertreatise(conferid, userid) {
      let param = {
        conference_id: conferid,
        created_by_id: userid,
      };
      let results = [];

      Contributions.getList(param).then((result) => {
        this.treatises = result.result;
      });

      return results;
    },
    getpapers() {
      User.getCurrentUser().then((user) => {
        Conference.getConferenceList({ status: "发布" }).then((res) => {
          console.log(user);
          let params = {
            created_by_id: user.id,
            conference_id: res.conference_list[0].id,
          };
          console.log(params);
          Contributions.getList(params).then((result) => {
            this.treatises = result.result;
          });
        });

        // return user
      });
    },
    downloadTemp(){ 
        this.templateShow =true   
    },
    download(item){
      // this.currentConference.treatisereq.forEach((x) => {
        
      //           x.file_metadata.forEach((x) => {
      //                    window.open(item.url, "_blank");
      //           })
               
      //       })   
       window.open(item.url, "_blank");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

.inner-page-nav {
  position: relative;
  width: 1200px;
  height: 60px;
  padding: 0 15px;
  margin: 0 auto;
}

.inner-page-content {
  margin: 60px 0;
}

.papers {
  @include flex-between;
  align-items: flex-start;
  width: 1200px;
  height: 900px;
  margin: 60px auto;
  padding: 0 15px;

  .papers-form-wrap {
    flex: 0 0 35%;
    padding: 30px;
    height: 100%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;

    .el-button {
      display: block;
      width: 100%;
      margin: 0 0 15px;
    }

    .papers-form {
      padding-top: 0px;

      .form-tit {
        font-size: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      }

      .papers-num {
        margin: 15px 0;
        font-size: 14px;
        color: $defaultColor;
      }
    }
  }

  .my-papers {
    flex: auto;
    margin-left: 15px;
    padding: 30px;
    height: 900px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    overflow-y: auto;
    .my-papers-tit {
      font-size: 16px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .my-paper-list {
      .item {
        position: relative;
        width: 100%;
        padding: 15px;
        background: #eee;
        border-radius: 5px;
        margin-top: 30px;

        p {
          font-size: 14px;
          line-height: 25px;
        }

        .more {
          position: absolute;
          top: 50%;
          right: 30px;
          transform: translateY(-50%);
        }
      }
    }
  }
}

.dialog-info-wrap {
  width: 100%;

  .dialog-tit {
    font-size: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .info {
    margin-top: 15px;

    p {
      line-height: 40px;
    }
  }
}
</style>